import { SubEventBody, Question } from '../../gds-api-client';

export const emptyLocation = {
  name: '',
  street1: '',
  city: '',
  state: '',
  zip: '',
  country: '',
};

export const emptyMealQuestion = (): Question => ({
  text: '',
  type: 'Meal',
  answerType: 'Option',
  answerDestination: 'Invitation',
  options: [],
  description: '',
  isRequired: true,
});

export const emptySubEvent: SubEventBody = {
  name: '',
  time: '',
  endTime: '',
  type: 'WeddingEvent',
  location: emptyLocation,
  attire: '',
  notes: '',
  visible: true,
};

export const emptyEvent = {
  ...emptySubEvent,
  date: '',
  subEvents: [],
  visible: true,
};

export const VENUE = 'venue';
export const DATE = 'date';
export const TIME = 'time';
